// The claim's pricing profile, said out loud (fee-practice-analysis.md): what
// the policy table resolved for this insurer group + job type — "Pricing
// profile VERO: P&G 17.8% · JMF …". Shown above the Quote Lines since
// 2026-08-19 and above the Variation Costings since 2026-09-05 (Robert: the
// same rates drive both grids' automatic lines, so both should say so).
//
// `states` — the four per-claim fee states, for the QUOTE grid only: a
// pre-upgrade job whose fees are disabled says nothing (the Enable button IS
// the message — Robert 2026-08-19) or, when the profile charges none, says
// so. The costings grid passes none: its states live per variation header,
// and a disabled quote never disables a new header (quotes.md 8.29).

const KINDS = ["pg", "jmf", "profit", "rubbish"];

function FeeProfileLine({ feeStatus, states = null, className = "small text-muted mb-1" }) {
  if (!feeStatus) return null;
  const anyDisabled = Array.isArray(states) && states.some((s) => s === "disabled");
  const anyEnabled = KINDS.some((k) => feeStatus[k]?.enabled);
  if (anyDisabled && anyEnabled) return null;
  return (
    <div className={className}>
      {anyDisabled ? (
        <>Automatic fees don't apply here: <strong>{feeStatus.group}</strong>
          {" + "}<strong>{feeStatus.job_type || "no job type"}</strong> charges none.</>
      ) : feeStatus.profiled ? (
        <>{feeStatus.standard
          ? <>Standard fees (every quote unless excepted):</>
          : <>Pricing profile <strong>{feeStatus.group}</strong>:</>}
          {feeStatus.pg.enabled ? ` P&G ${feeStatus.pg.percent}%` : " no P&G"} ·
          {" "}{feeStatus.jmf.enabled
            ? <span data-hint="Job Management Fee">JMF {feeStatus.jmf.percent}% (as hrs @ ${Number(feeStatus.jmf.rate)})</span>
            : <span data-hint="Job Management Fee">no JMF</span>}
          {feeStatus.rubbish?.enabled
            ? <> · Rubbish {feeStatus.rubbish.loads} load{feeStatus.rubbish.loads === 1 ? "" : "s"} × ${feeStatus.rubbish.rate}</>
            : null}
          {feeStatus.profit.enabled
            ? <> · Profit {feeStatus.profit.percent}% <span className="text-muted">(= {feeStatus.profit.pct_of_sell}% of sell)</span></>
            : null} ·
          {feeStatus.default_markup == null ? " standard markup" : ` default markup ${Number(feeStatus.default_markup)}%`}
        </>
      ) : (
        <>No fee profile for <strong>{feeStatus.group}</strong> + <strong>{feeStatus.job_type || "no job type"}</strong> — overheads price inside the markup (System Data → Quote Markup Profiles).</>
      )}
    </div>
  );
}

export default FeeProfileLine;
